import { blinkConstants } from '@thoughtspot/blink-constants';
import { translate as t } from '@thoughtspot/i18n';
import { ElementType } from '@thoughtspot/radiant-react/widgets/form-builder/interface';
import { TranslationKeys as TranslationKeysHelpCust } from '../../application-settings/help-customization/constants';
import { HOST_REGEX, PORT_REGEX, TranslationsKeys } from './constants';
const getSmtpConfig = () => [
    {
        key: 'configured_status',
        view: true,
        true: t(TranslationsKeys.CONFIGURED),
        false: t(TranslationsKeys.UNCONFIGURED),
        config: {
            label: t(TranslationsKeys.STATUS_LABEL),
        },
    },
    {
        key: 'relay_host',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.FROM_RELAY_HOST_LABEL),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_RELAY_HOST_LABEL),
            }),
            regex: HOST_REGEX,
            regexError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_RELAY_HOST_LABEL),
            }),
        },
    },
    {
        key: 'port_number',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.FROM_PORT),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_PORT),
            }),
            regex: PORT_REGEX,
            regexError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_PORT),
            }),
        },
    },
    {
        key: 'is_host_reachable',
        view: true,
        true: t(TranslationsKeys.YES),
        false: t(TranslationsKeys.NO),
        config: {
            label: t(TranslationsKeys.IS_HOST_REACHABLE_LABEL),
        },
    },
    {
        key: 'from_name',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.FROM_DOMAIN),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_DOMAIN),
            }),
        },
    },
    {
        key: 'mail_from',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.FROM_USERNAME),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_USERNAME),
            }),
        },
    },
    {
        key: 'smtp_auth_status',
        view: true,
        elementType: ElementType.RADIO,
        true: t(TranslationsKeys.YES),
        false: t(TranslationsKeys.NO),
        config: {
            label: t(TranslationsKeys.FROM_AUTH_REQUIRED_LABEL),
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_AUTH_REQUIRED_LABEL),
            }),
        },
    },
    {
        key: 'username',
        view: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.USERNAME_LABEL),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.USERNAME_LABEL),
            }),
        },
    },
    {
        key: 'password',
        view: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.FROM_PASSWORD_LABEL),
            type: 'password',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.VALID_FIELDNAME, {
                field_name: t(TranslationsKeys.FROM_PASSWORD_LABEL),
            }),
        },
    },
    {
        key: 'real_name',
        view: false,
    },
];
const getSslConfig = () => [
    {
        key: 'ssl_status',
        view: true,
        edit: true,
        elementType: ElementType.TOGGLE,
        config: {
            label: t(TranslationsKeys.UNCONFIGURED_STATUS_LABEL),
        },
    },
    {
        key: 'signing_algorithm',
        view: true,
        edit: true,
        elementType: ElementType.SELECT,
        config: {
            label: t(TranslationsKeys.SIGNATURE_ALGORITHM),
            dropdownWidth: 'targetWidth',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.SSL_SIGNING_ALGORITHM_FORM_ERROR),
        },
        value: 'RSA',
    },
    {
        key: 'tls_version',
        view: true,
        edit: true,
        elementType: ElementType.SELECT,
        config: {
            label: t(TranslationsKeys.TLS_VERSION),
            dropdownWidth: 'targetWidth',
        },
    },
    {
        key: 'key',
        view: false,
        edit: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.PRIVATE_KEY),
            type: 'file',
            placeholder: t(TranslationsKeys.SSL_FILE_INPUT_PLACEHOLDER),
        },
        validation: {
            fileTypes: {
                allowedExtensions: ['key'],
                errorMessage: t(TranslationsKeys.SSL_FILE_INPUT_INVALID_FILE_FORM_ERROR, { fieldName: t(TranslationsKeys.PRIVATE_KEY) }),
            },
            maxFileSize: {
                maxSize: 100000,
                errorMessage: t(TranslationsKeys.SSL_FILE_INPUT_FILE_SIZE_FORM_ERROR, { maxSize: '100000Kb' }),
            },
        },
    },
    {
        key: 'cert',
        view: false,
        edit: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.SSL_CERTIFICATE_BUNDLE),
            type: 'file',
            placeholder: t(TranslationsKeys.SSL_FILE_INPUT_PLACEHOLDER),
        },
        validation: {
            fileTypes: {
                allowedExtensions: ['crt'],
                errorMessage: t(TranslationsKeys.SSL_FILE_INPUT_INVALID_FILE_FORM_ERROR, {
                    fieldName: t(TranslationsKeys.SSL_CERTIFICATE_BUNDLE),
                }),
            },
            maxFileSize: {
                maxSize: 100000,
                errorMessage: t(TranslationsKeys.SSL_FILE_INPUT_FILE_SIZE_FORM_ERROR, { maxSize: '100000Kb' }),
            },
        },
    },
    {
        key: 'organization',
        view: true,
        edit: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.ORGANIZATION),
            type: 'text',
        },
    },
    {
        key: 'signature_algorithm',
        view: true,
        edit: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.KEY_TYPE),
        },
    },
    {
        key: 'not_after',
        view: true,
        edit: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.EXPIRY_DATE),
            type: 'text',
        },
    },
    {
        key: 'country',
        view: true,
        edit: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.COUNTRY),
            type: 'text',
        },
    },
    {
        key: 'state',
        view: true,
        edit: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.STATE),
            type: 'text',
        },
    },
    {
        key: 'organization_unit',
        view: false,
        edit: false,
        elementType: ElementType.INPUT,
        config: {
            label: 'Organization Unit',
            type: 'text',
        },
    },
    {
        key: 'company_name',
        view: true,
        edit: false,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.COMPANY_NAME),
            type: 'text',
        },
    },
];
const getSshConfig = () => [
    {
        key: 'reverse_ssh_status',
        view: true,
        edit: true,
        elementType: ElementType.TOGGLE,
        config: {
            label: t(TranslationsKeys.REVERSE_SSH_TUNNELING),
        },
    },
];
const getHelpCustomizationConfig = () => [
    {
        key: 'itemStatus',
        elementType: ElementType.TOGGLE,
        add: false,
        config: {
            label: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_STATUS),
        },
        value: false,
    },
    {
        key: 'mount_item_label',
        elementType: ElementType.INPUT,
        add: true,
        config: {
            label: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_MENUITEMLABEL),
            placeholder: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_MENUITEM_PLACEHOLDER),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_VALIDATION_MESSAGE_MENUITEM),
        },
    },
    {
        key: 'item_url',
        elementType: ElementType.INPUT,
        add: true,
        config: {
            label: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_ITEMURL),
            placeholder: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_ITEMURL_PLACEHOLDER),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_VALIDATION_MESSAGE_ITEMURL),
            regex: blinkConstants.URL_REGEX,
            regexError: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_VALIDATION_MESSAGE_ITEMURL),
        },
    },
    {
        key: 'mount_item_icon',
        elementType: ElementType.INPUT,
        add: true,
        config: {
            label: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_CUSTOMICON),
            type: 'file',
            helpText: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_CUSTOMICON_FILE_SIZE),
            placeholder: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_FILEUPLOAD_PLACEHOLDER),
        },
        validation: {
            fileTypes: {
                allowedExtensions: ['png'],
                errorMessage: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_CUSTOMICON_FILE_SIZE),
            },
            maxFileSize: {
                maxSize: 100000,
                errorMessage: t(TranslationKeysHelpCust.HELP_CUSTOMIZATION_CUSTOMICON_FILE_SIZE),
            },
        },
    },
];
const getSamlConfig = () => [
    {
        key: 'enable_saml',
        view: true,
        true: t(TranslationsKeys.CONFIGURED),
        false: t(TranslationsKeys.UNCONFIGURED),
        config: {
            label: t(TranslationsKeys.STATUS_LABEL),
        },
    },
    {
        key: 'server_name',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.SAML_IP_OF_SERVER),
            helpText: t(TranslationsKeys.SAML_IP_OF_SERVER_HELP_TEXT),
            placeholder: t(TranslationsKeys.SAML_IP_OF_SERVER_PLACEHOLDER),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.SAML_ERROR_IP_OF_SERVER, {
                field_name: t(TranslationsKeys.SAML_IP_OF_SERVER),
            }),
            regex: HOST_REGEX,
            regexError: t(TranslationsKeys.SAML_INVALID_ERROR_IP_OF_SERVER, {
                field_name: t(TranslationsKeys.SAML_IP_OF_SERVER),
            }),
        },
    },
    {
        key: 'protocol',
        view: true,
        elementType: ElementType.SELECT,
        config: {
            label: t(TranslationsKeys.SAML_PROTOCOL),
            options: [
                {
                    options: [
                        { id: 'http', label: 'http' },
                        { id: 'https', label: 'https' },
                    ],
                },
            ],
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.SAML_ERROR_PROTOCOL, {
                field_name: t(TranslationsKeys.SAML_PROTOCOL),
            }),
        },
    },
    {
        key: 'server_port',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.SAML_PORT),
            type: 'number',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.SAML_ERROR_PORT, {
                field_name: t(TranslationsKeys.SAML_PORT),
            }),
            regex: PORT_REGEX,
            regexError: t(TranslationsKeys.SAML_INVALID_ERROR_PORT, {
                field_name: t(TranslationsKeys.SAML_PORT),
            }),
        },
    },
    {
        key: 'service_name',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.SAML_UNIQUE_SERVICE_NAME),
            helpText: t(TranslationsKeys.SAML_UNIQUE_SERVICE_NAME_HELP_TEXT),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.SAML_ERROR_UNIQUE_SERVICE_NAME, {
                field_name: t(TranslationsKeys.SAML_UNIQUE_SERVICE_NAME),
            }),
        },
    },
    {
        key: 'response_skew',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.SAML_SKEW_TIME),
            helpText: t(TranslationsKeys.SAML_SKEW_TIME_HELP_TEXT),
            type: 'number',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.SAML_ERROR_SKEW_TIME, {
                field_name: t(TranslationsKeys.SAML_SKEW_TIME),
            }),
            range: '0-604800',
            rangeError: t(TranslationsKeys.SAML_INVALID_ERROR_SKEW_TIME, {
                field_name: t(TranslationsKeys.SAML_SKEW_TIME),
            }),
        },
    },
    {
        key: 'idp_metadata',
        view: false,
        edit: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.SAML_IDP_METADATA),
            type: 'file',
            placeholder: t(TranslationsKeys.SSL_FILE_INPUT_PLACEHOLDER),
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.SAML_ERROR_IDP_METADATA, {
                field_name: t(TranslationsKeys.SAML_IDP_METADATA),
            }),
            fileTypes: {
                allowedExtensions: ['*', 'xml'],
                errorMessage: t(TranslationsKeys.SAML_ERROR_IDP_METADATA, {
                    fieldName: t(TranslationsKeys.SAML_IDP_METADATA),
                }),
            },
            maxFileSize: {
                maxSize: 500000,
                errorMessage: t(TranslationsKeys.SAML_INVALID_ERROR_IDP_METADATA, { maxSize: '500000Kb' }),
            },
        },
    },
    {
        key: 'automatically_create_users',
        view: true,
        elementType: ElementType.RADIO,
        true: t(TranslationsKeys.YES),
        false: t(TranslationsKeys.NO),
        config: {
            label: t(TranslationsKeys.SAML_AUTO_ADD_SAML_USER),
        },
    },
];
const getInternalAuthConfig = () => [
    {
        key: 'status',
        view: true,
        edit: true,
        elementType: ElementType.TOGGLE,
        config: {
            label: t(TranslationsKeys.INTERNAL_AUTH_STATUS),
        },
    },
];
const getActiveDirectoryConfig = () => [
    {
        key: 'is_configured',
        view: true,
        true: t(TranslationsKeys.CONFIGURED),
        false: t(TranslationsKeys.UNCONFIGURED),
        config: {
            label: t(TranslationsKeys.STATUS_LABEL),
        },
    },
    {
        key: 'url',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.AD_MAPPING_URL),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.AD_MAPPING_URL_REQUIRED_ERROR, {
                field_name: t(TranslationsKeys.AD_MAPPING_URL),
            }),
        },
    },
    {
        key: 'domain',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.AD_MAPPING_DOMAIN),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.AD_MAPPING_DOMAIN_REQUIRED_ERROR, {
                field_name: t(TranslationsKeys.AD_MAPPING_DOMAIN),
            }),
        },
    },
    {
        key: 'search_base',
        view: true,
        elementType: ElementType.INPUT,
        config: {
            label: t(TranslationsKeys.AD_MAPPING_SEARCH_BASE),
            type: 'text',
        },
        validation: {
            required: true,
            requiredError: t(TranslationsKeys.AD_MAPPING_SEARCH_BASE_REQUIRED_ERROR, {
                field_name: t(TranslationsKeys.AD_MAPPING_SEARCH_BASE),
            }),
        },
    },
    {
        key: 'automatically_create_users',
        view: true,
        edit: true,
        elementType: ElementType.RADIO,
        true: t(TranslationsKeys.CONFIRM_YES),
        false: t(TranslationsKeys.CONFIRM_NO),
        config: {
            label: t(TranslationsKeys.AD_MAPPING_AUTO_ADD_USER),
        },
    },
    {
        key: 'ssl',
        view: true,
        edit: true,
        elementType: ElementType.RADIO,
        true: t(TranslationsKeys.CONFIRM_YES),
        false: t(TranslationsKeys.CONFIRM_NO),
        config: {
            label: t(TranslationsKeys.AD_MAPPING_SSL_REQUIRED),
        },
    },
];
export const getConfig = (configName) => {
    switch (configName) {
        case 'smtp':
            return getSmtpConfig();
        case 'ssl':
            return getSslConfig();
        case 'ssh':
            return getSshConfig();
        case 'helpCustomization':
            return getHelpCustomizationConfig();
        case 'saml':
            return getSamlConfig();
        case 'internalAuth':
            return getInternalAuthConfig();
        case 'activeDirectory':
            return getActiveDirectoryConfig();
        default:
            return [];
    }
};
//# sourceMappingURL=form-builder-config.js.map